export const remToPx = pixels => pixels * 16
